module.exports = "<a class=\"phoneSupport\" ng-if=\"$ctrl.input\" uib-popover-html=\"$ctrl.getPopoverContent($ctrl.input)\" popover-append-to-body=\"false\" popover-trigger=\"'outsideClick'\" popover-placement=\"{{$ctrl.input.placement}}\">\n    <i class=\"fa fa-phone\" aria-hidden=\"true\"></i>\n</a>\n";


//////////////////
// WEBPACK FOOTER
// ./modules/support/components/support-contact/supportContact.component.html
// module id = 733
// module chunks = 0